<template>
  <v-form v-model="isStyleValidComputed">
    <template v-for="(item, key) in items">
      <v-row no-gutters :key="key">
        <slot :name="item.key" />
      </v-row>
    </template>
  </v-form>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isStyleValid: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  computed: {
    isStyleValidComputed: {
      get() {
        return this.isStyleValid;
      },
      set(nV) {
        this.$emit('update:isStyleValid', nV);
      }
    }
  }
};
</script>